import { isHuaweiPadQqBrowser, isMQQB, isMobile, isWechat } from '@tencent/web-base';
import * as Bowser from 'bowser';

export const getBrowserInfo = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const info = browser.getBrowser();
  return `${info.name} ${info.version}`;
};

/**
 * 将 val 复制到剪切板
 * @param {String} val
 * @returns {Boolean} res - 是否成功复制到剪切板
 */
export const execCommandCopy = (val: string) => {
  if (typeof document.execCommand !== 'function') {
    return false;
  }
  const textarea = document.createElement('textarea');
  textarea.setAttribute('readonly', 'readonly');
  textarea.value = val;
  document.body.appendChild(textarea);
  textarea.select();
  const res = document.execCommand('copy');
  document.body.removeChild(textarea);
  return res;
};

// 从旧版本拷贝而来
export const getBrowser = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const info = browser.getBrowser();

  return {
    broswer: info?.name ?? '',
    version: info?.version ?? '0',
  };
};

const isNotChrome97 = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const info = browser.getBrowser();
  const firsetVersion = info.version?.split('.')[0];
  if (info.name !== 'Chrome') {
    return true;
  }

  if (firsetVersion !== '97') {
    return true;
  }

  return false;
};

export const isSupportWasm = () =>
  ['VideoDecoder', 'VideoEncoder', 'AudioEncoder', 'AudioDecoder', 'MediaStreamTrackGenerator', 'WebTransport'].every(
    (api) => api in window,
  ) && isNotChrome97();

export const getOsName = () => {
  if (navigator.appVersion.includes('Win')) {
    return 'Windows';
  }
  if (navigator.appVersion.includes('Android')) {
    return 'Android';
  }

  // iOS和Mac的顺不能变，经测试发现Mac的浏览器里会有iOS的字样
  if (navigator.appVersion.includes('iPhone')) {
    return 'iOS';
  }
  if (navigator.appVersion.includes('iPad')) {
    return 'iOS';
  }
  if (navigator.appVersion.includes('Mac')) {
    return 'Mac';
  }

  return 'unknown';
};

export const isMobileBrowser = () => isMobile() || isWechat() || isHuaweiPadQqBrowser() || isMQQB();
